import React from "react";
import AddStudent from "../Center/Students/AddStudent";
import BreadCrumb from "../BreadCrumb";

/*
  Student registration on the website itself.

  The form is the one a center already uses, so the fields are the same and
  stay the same. What is different here is that the student says which center
  they are joining - a center registering a student knows that from its own
  login, and a student on the website does not - and that the registration fee
  is paid before anything is written.
*/
export default function StudentRegister() {
  const breadcrumbs = [
    { path: "/", label: "Home" },
    { label: "Student Registration" },
  ];

  return (
    <div class="lists-box">
      <div class="container">
        <BreadCrumb crumbs={breadcrumbs} />
        <div class="title-box">
          <h4>Student Registration</h4>
        </div>
        <p class="mb-3">
          Fill in your details, choose the center you are joining and pay the
          registration fee. Your roll number is shown as soon as the payment
          goes through.
        </p>
        <AddStudent />
      </div>
    </div>
  );
}
